var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDotsIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00033 8.83203C2.46056 8.83203 2.83366 8.45894 2.83366 7.9987C2.83366 7.53846 2.46056 7.16536 2.00033 7.16536C1.54009 7.16536 1.16699 7.53846 1.16699 7.9987C1.16699 8.45894 1.54009 8.83203 2.00033 8.83203Z",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00033 2.9987C2.46056 2.9987 2.83366 2.6256 2.83366 2.16536C2.83366 1.70513 2.46056 1.33203 2.00033 1.33203C1.54009 1.33203 1.16699 1.70513 1.16699 2.16536C1.16699 2.6256 1.54009 2.9987 2.00033 2.9987Z",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00033 14.6654C2.46056 14.6654 2.83366 14.2923 2.83366 13.832C2.83366 13.3718 2.46056 12.9987 2.00033 12.9987C1.54009 12.9987 1.16699 13.3718 1.16699 13.832C1.16699 14.2923 1.54009 14.6654 2.00033 14.6654Z",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsIconWhite);
export default __webpack_public_path__ + "static/media/three-dots-icon-white.cb1a803ed9c52acb7b9dc78648c0975c.svg";
export { ForwardRef as ReactComponent };